import React from 'react';
import { get, post, put, del, patch } from '../../Utility/Http';
import { userDetailsGet, userDeleteGet, resetPasswordApi, usersGet, awsVarifiedEmailFun, verifyMfaOtpPost, verifySoftwareTokenPut, mfaAssignPut } from '../Model/ProfileModel';
import Config from '../../../Utility/Config';

export const user_Details = async (id) => {
    const response = await get(`${Config.extendedUrl}user_personal_info/${id}`);
    return userDetailsGet(response);
};

export const userDelete = async (data) => {
    const response = await del(`${Config.extendedUrl}admin`, data);
    return userDeleteGet(response);
};

export const resetPassword = async (data) => {
    const response = await patch(`${Config.extendedUrl}admin/resetpassword`, data);
    return resetPasswordApi(response);
};

export const users = async (data, id) => {
    const response = await patch(`${Config.extendedUrl}admin/users/${id}`, data);
    return usersGet(response);
};

export const awsVarifiedEmail = async (data) => {
    const response = await put(`${Config.extendedUrl}currentuser/check_identity_status`, data);
    return awsVarifiedEmailFun(response);
};

export const verifyMfaOtp = async (data) => {
    const response = await post(`${Config.extendedUrl}users/mfa/verify`, data);
    return verifyMfaOtpPost(response);
};
export const verifySoftwareToken = async (data) => {
    const response = await put(`${Config.extendedUrl}users/verify_software_token`, data);
    return verifySoftwareTokenPut(response);
};
export const mfaAssign = async (data) => {
    const response = await put(`${Config.extendedUrl}users/usr_mfa_assign`, data);
    return mfaAssignPut(response);
};